<template>
  <modal @close="$emit('close')" style="line-height: 0.9em; text-align: justify; margin-top: -15px; margin-bottom: -13px;">
    <!--template slot="header">{{ $t('modals.register.title') }}</template-->
    <template slot="body">
      <form @submit.prevent="register">
        <input class="hidden" type="submit" />
          <div class="form-element" style="margin-top: 1px;">
            <label for="register-email">E-mail</label>
            <input id="register-email" type="text" v-model="email" v-on:keyup="error = null" />
          </div>
          <div class="form-element" style="margin-top: 1px;">
            <label for="register-password">{{ $t('modals.register.password') }}</label>
            <input id="register-password" type="password" v-model="password" v-on:keyup="error = null" />
          </div>
          <!--div class="form-element" style="margin-top: 1px;">
            <label for="register-firstname">{{ $t('modals.register.firstname') }}</label>
            <input id="register-firstname" type="text" v-model="firstname" v-on:keyup="error = null" v-firstname />
          </div>
          <div class="form-element" style="margin-top: 1px;">
            <label for="register-lastname">{{ $t('modals.register.lastname') }}</label>
            <input id="register-lastname" type="text" v-model="lastname" v-on:keyup="error = null" v-lastname />
          </div-->
        <div class="red-color" v-html="error" />
      </form>
    </template>

    <template slot="footer">
      <color-button round color="yellow">{{ $t('modals.register.submit') }}</color-button>
      <!--color-button round color="yellow" @click="register">{{ $t('modals.register.submit') }}</color-button-->
    </template>
  </modal>
</template>

<script>
import Modal from '@/components/modals/ModalRegister'
import BirthdayDateButton from '@/components/buttons/BirthdayDateButton'
import ColorButton from '@/components/buttons/ColorButton'
import AuthenticationService from '@/services/AuthenticationService'

export default {
  components: {
    Modal,
    BirthdayDateButton,
    ColorButton
  },
  data () {
    return {
      email: '',
      password: '',
      birthdate: '',
      firstname: '',
      lastname: '',
      middlename: '',
      passport: '',
      iwhen: '',
      phone: '',
      currency: 'AZN',
      error: null,
      errorPromo: null,
      success: null,
      successPromo: null,
      promo: null,
      affPartner: null
    }
  },
  methods: {
    async register () {
      this.error = null
      this.success = null
      /* if (this.firstname === '') {
        if (this.$i18n.locale === 'ru') {
          this.error = 'Поле Имя обязательно для заполнения'
        } else if (this.$i18n.locale === 'en') {
          this.error = 'Field Name must be filled'
        } else if (this.$i18n.locale === 'az') {
          this.error = 'Ad qeyd olunmayıb'
        }
      } else if (this.lastname === '') {
        if (this.$i18n.locale === 'ru') {
          this.error = 'Поле Фамилия обязательно для заполнения'
        } else if (this.$i18n.locale === 'en') {
          this.error = 'Field Surname must be filled'
        } else if (this.$i18n.locale === 'az') {
          this.error = 'Soyad qeyd olunmayıb'
        }
      // } else if (this.phone === '') {
      } else { */
      try {
        let tmpBonus = null
        if (this.selectBonus === '+20% к каждому пополнению' || this.selectBonus === '+20% for each replenishment' || this.selectBonus === 'Hər depozitə +20%') {
          tmpBonus = 1
        }
        const response = await AuthenticationService.register({
          email: this.email,
          password: this.password,
          birthdate: this.birthdate,
          firstname: this.firstname,
          lastname: this.lastname,
          middlename: this.middlename,
          passport: this.passport,
          iwhen: this.iwhen,
          phone: this.phone,
          currency: this.currency,
          promo: this.promo,
          bonus: tmpBonus,
          affPartner: this.affPartner ? this.affPartner : '904'
        })
        this.$store.dispatch('setToken', response.data.token)
        this.$store.dispatch('setUser', response.data.user)
        this.$router.push('/')
        this.$emit('close')
      } catch (error) {
        this.error = error.response.data.error
      }
      /* } */
    },
    setBirthDate (date) {
      this.error = null
      this.birthdate = date
    },
    setIwhen (date) {
      this.error = null
      this.iwhen = date
    },
    async checkPromo () {
      this.errorPromo = ''
      this.successPromo = ''
      try {
        const response = await AuthenticationService.checkPromo({
          promo: this.promo
        })
        this.affPartner = response.data.partner
        this.successPromo = response.data.success
      } catch (error) {
        this.errorPromo = error.response.data.error
      }
    }
  }
}
</script>

<style scoped>
.form-element { margin-bottom: 5px; }
.currency { display: flex; height: 30px; }
.select-bonus { display: flex; height: 30px; }
.promo { width: 187px; }
.promo-button { width: 113px; float: right; position: absolute; margin-top: 15px; margin-left: 188px; border-radius: 3px; height: 30px; line-height: 30px; }
.success { color: #43a047; font-size: 14px; }
.rules { font-size: 12px; position: absolute; margin-left: 18px; margin-top: 11px; }
.check-rules { width: 14px; }
</style>



// WEBPACK FOOTER //
// src/components/modals/Register.vue